import React, { Component, useState, useEffect } from 'react';
import BoxInfoCard from '../../commonComponents/Card/boxInfoCard';
import { Row, Col, Radio, Space } from 'antd';
import BoxInfoModal from './boxInfoModal';
import ManagedSelfCard from '../../commonComponents/Card/ManagedSelfCard';
import { v4 as uuidv4 } from 'uuid';
import { PlusSquareOutlined, StarTwoTone } from '@ant-design/icons';
import DynamicModal from '../../commonComponents/DynamicModal/DynamicModal';
import './order.scss';

export default function BoxForm({ defaultList, onChange = () => {} }) {
    const [boxList, setBoxList] = useState([]);
    const [showBoxInfoModal, setShowBoxInfoModal] = useState(false);
    const [boxType, setBoxType] = useState('self');

    useEffect(() => {
        onChange({ boxType, boxList });
    }, [boxType, boxList]);

    const handleLogisticsTypeChange = value => {
        setBoxType(value);
    };

    const closeBoxInfo = () => {
        setShowBoxInfoModal(false);
    };

    const handleBoxCard = box => {
        const newBox = {
            ...box,
            id: uuidv4(),
            boxType: boxType,
        };
        setBoxList([...boxList, newBox]);
    };

    const openBoxInfo = () => {
        setShowBoxInfoModal(true);
    };

    const deleteCard = id => {
        const finalUpdate = boxList.filter(item => item.id !== id);
        setBoxList(finalUpdate);
    };

    return (
        <>
            <div>
                <div className="d-flex checkbox_row mt-2">
                    <label className="mr-4">Logistics type</label>
                    <Radio.Group name="logisticsType" onChange={e => handleLogisticsTypeChange(e.target.value)} defaultValue={boxType}>
                        <Space direction="vertical">
                            <Radio value={'self'}>Managed by Client</Radio>
                            <Radio value={'flixstock'}>Managed by Flixstock</Radio>
                        </Space>
                    </Radio.Group>
                </div>
                <div className="d-flex address_box mt-2">
                    <label className="mr-4">Box Information</label>
                    <div className="w-100">
                        <PlusSquareOutlined style={{ fontSize: '150%' }} onClick={e => openBoxInfo()} />
                        <Row gutter={[16, 16]} className="mt-1">
                            {boxList.length > 0 &&
                                boxList?.map((el, index) => {
                                    return (
                                        <Col span={24}>
                                            <BoxInfoCard
                                                data={el}
                                                dimensions={el.dimensions}
                                                weight={el.weight}
                                                index={index}
                                                logistictype={el.boxType}
                                                deleteIcon={() => deleteCard(el.id)}
                                            />
                                        </Col>
                                    );
                                })}
                        </Row>
                    </div>
                </div>
                {showBoxInfoModal && boxType == 'flixstock' && (
                    <BoxInfoModal
                        open={showBoxInfoModal && boxType == 'flixstock'}
                        close={closeBoxInfo}
                        handleBoxCard={handleBoxCard}
                        eshipboxes={defaultList?.eshipboxes}
                    />
                )}
                {showBoxInfoModal && boxType == 'self' && (
                    <DynamicModal
                        open={showBoxInfoModal && boxType == 'self'}
                        close={closeBoxInfo}
                        width={1000}
                        component={
                            <ManagedSelfCard
                                onFinish={boxInfo => {
                                    console.log(boxInfo);
                                    handleBoxCard(boxInfo);
                                    setShowBoxInfoModal(false);
                                }}
                                onClose={() => {
                                    setShowBoxInfoModal(false);
                                }}
                            />
                        }
                    />
                )}
            </div>
        </>
    );
}
